<template>
	<div>
		<!--白底遮层-->
		<!-- <div class="witheBg">
			<img src="../../assets/loading.gif" />
		</div> -->
	</div>
</template>

<script>
	//获取微信code
	function getWxCode(){
		var app_id  = 'wx25f9e2ff9778d42f';
		var rUrl    = window.__CFG.URL + '/card/binding';
		var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + app_id + "&redirect_uri=" + rUrl + "&response_type=code&scope=snsapi_base&state=123456#wechat_redirect";
		window.location.href = url;
	};
	
	import api from "../../api/api"
	export default {
		mounted() {
			if(localStorage.getItem("WXOPENID")){
				localStorage.removeItem("WXOPENID");
			}
			var parentId = api.getUrlParms("parentId");
			if(parentId){
				sessionStorage.setItem("ID",parentId);
				window.__CFG.ParentId = parentId;
			}
			setTimeout(() => {
				getWxCode();
			},400);
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/getcode/index.vue